import { useConfig } from "@jti/app-context/useConfig";
import { useGetCountryQuery } from "@jti/store/slices/magentoApiSlice";

export const useCountry = () => {
  const config = useConfig();
  const countryQueryState = useGetCountryQuery(config.ISO_COUNTRY_CODE);

  return countryQueryState;
};
